import { Component, Input } from '@angular/core';

import {
  ICartDailyStockSoldOutProductType,
} from '../../../cart/models/delivery/i-cart-delivery-info';

@Component({
  standalone: false,
  selector: 'daily-stock-sold-out-notice',
  styles: [`
    .message-block {
      border-width: 1.5px;
    }
  `],
  template: `
    <ui-message-custom
      class="font-md d-block message-block"
      *ngIf="productTypes.length"
    >
      <ng-container *ngFor="let product of productTypes">
        <span class="fw-bold">{{ product.name }}</span>&nbsp;
        <span>
          {{ 'orderProcess.delivery.dailyStockSoldOut.isLimitedPerDay' | translate: { dailyLimit: product.dailyLimit } }}
        </span>
      </ng-container>
      <span [translate]="'orderProcess.delivery.dailyStockSoldOut.ifYourDateIsUnavailable'">
        If your date is unavailable, it may be sold out or your quantity is too high. Please adjust or remove the item.
      </span>
    </ui-message-custom>
  `,
})
export class DailyStockSoldOutNoticeComponent {
  @Input() productTypes: ICartDailyStockSoldOutProductType[] = [];
}
